namespace RioERP.Masters {
    export interface TaxRateRow {
        Id?: number;
        TaxCategoryId?: number;
        StateId?: number;
        TaxTypeId?: number;
        Rate?: number;
        FromDate?: string;
        ToDate?: string;
        TaxCategoryName?: string;
        TaxCategoryIsActive?: boolean;
        TaxCategoryInsertUserId?: number;
        TaxCategoryInsertDate?: string;
        TaxCategoryUpdateUserId?: number;
        TaxCategoryUpdateDate?: string;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        TaxTypeName?: string;
    }

    export namespace TaxRateRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Masters.TaxRate';
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            TaxCategoryId = "TaxCategoryId",
            StateId = "StateId",
            TaxTypeId = "TaxTypeId",
            Rate = "Rate",
            FromDate = "FromDate",
            ToDate = "ToDate",
            TaxCategoryName = "TaxCategoryName",
            TaxCategoryIsActive = "TaxCategoryIsActive",
            TaxCategoryInsertUserId = "TaxCategoryInsertUserId",
            TaxCategoryInsertDate = "TaxCategoryInsertDate",
            TaxCategoryUpdateUserId = "TaxCategoryUpdateUserId",
            TaxCategoryUpdateDate = "TaxCategoryUpdateDate",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            TaxTypeName = "TaxTypeName"
        }
    }
}
